<template>
    <div class="main-app mt-12">

        <v-container  class="">
            <div id="title" class="mb-12 pb-8">
                <h3 class="text-lpn pt-5">
                    {{ project_detail ? project_detail.project_name_th:'' }}
                    <v-divider/>
                </h3>

                <div id="sale_plan">
                    <div class="mt-2">
                        <floor-plan
                                v-if="(properties_list&&properties_list.length>0)"
                                :show="true"
                                :plan_type="'sale_plan_floor'"
                                :project_code="project_detail ? project_detail.project_code:''"
                                :project_id="project_detail ? project_detail.project_id:''"
                                :campaign_id="campaign_id ? campaign_id:''"
                                v-bind:unit="properties_list"
                                v-bind:updated_unit="updated_unit"
                                :option="display_option"
                                @togglePlanDetailDialog="togglePlanDetailDialog"
                        />
                    </div>
                </div>
            </div>
        </v-container>

        <property-detail-dialog :project_id="project_detail ? project_detail.project_id:''"  v-bind:unit_detail_dialog="unit_detail_dialog" v-bind:unit_data="unit_detail" :campaign_id="campaign_id" v-bind:reload_unit_count="reload_unit_count"  @togglePlanDetailDialog="togglePlanDetailDialog" @reloadUnitDetails="reloadUnitDetails" @addCartItem="addCartItem"/>

        <!-- แสดงห้องที่ user เลือก -->
        <selected-properties-tool-bar  ref="selected_properties" v-bind="{cart_item:current_cart_item}"></selected-properties-tool-bar>

    </div>
</template>

<script>
    import SelectedPropertiesToolBar from '@/components/saleOnline/SelectedPropertiesToolBar'
    import FloorPlan from '@/components/salePlan/FloorPlan'
    import PropertyDetailDialog from '@/components/saleOnline/PropertyDetailDialog'

    export default {
        name: "FloorPlanSaleEvent",
        components:{
            selectedPropertiesToolBar:SelectedPropertiesToolBar,
            floorPlan:FloorPlan,
            propertyDetailDialog:PropertyDetailDialog,
        },
        data(){
            return{
                current_loading_state:{
                    show:false,
                    message:'กำลังโหลดข้อมูล....กรุณารอสักครู่.',
                    progressColor:'blue'
                },
                customer_profile:{},
                properties_list:null,
                project_id:null,
                project_detail: null,
                project_images: null,
                route_data: null,
                zone_data: null,
                campaign_id:null,
                rms_status_list:[],
                campaign_data: null,
                brand_color:'#16448f',
                offset:0,
                limit:9999,
                unit_detail_dialog:false,
                unit_detail:null,
                quatation_dialog:false,
                quatation_properties:null,
                reload_unit_count:0,
                updated_unit:null,
                display_option:{
                    display_field:{
                        field_name:'price_total_amount',
                        // field_name:'property_unit_code',
                        format:'0,0.00',
                        divide:1000000,
                    },
                    style:{
                        td_width:"60px",
                        td_height:"50px",
                    },
                    show_lock:true,
                    show_title:true,
                    use_rms_image:false
                }
            }
        },
        async mounted(){
            window.scrollTo(0,0)

            // check auth login with LINE is valid
            this.customer_profile = this.getSavedLocalItem(this.local_customer_key)
            if (!this.customer_profile) {
                return this.logout()
            }

            const local_project_detail = this.getSavedLocalItem(this.local_project_key)
            if(local_project_detail&&local_project_detail.hasOwnProperty('project_id')&&local_project_detail.project_id==this.project_id){
                this.project_detail = local_project_detail
            }else {
                this.project_detail = await this.getProjectDetails(this.project_id)
                this.saveSelectedProject(this.project_detail)
            }

            this.zone_data = this.getSavedLocalItem(this.local_zone_key)

            this.brand_color = this.getProjectColor(this.project_detail.project_shortname)
            this.route_data = this.genRouteData

            this.setTopNav(
                true,
                'ผังพื้นโครงการ',
                'saleOnline_propertiesList',
                {project_id: (this.project_detail ? this.project_detail.project_id : 0),camp:this.campaign_id},
                ''
            )
            this.rms_status_list = await this.loadRmsStatus()
            this.properties_list = await this.getPropertiesList()

            this.display_option.building_list = this.uniqueBuildingList

        },
        async created() {

            //แสดงเลข version
            store.commit('changeShowVersionState', false)

            //แสดงเมนูด้านล่าง และกำหนดรายการเมนู
            this.setBottomNav(true,[],'sale_online')

            if(this.$route.query.hasOwnProperty('project_id')){
                this.project_id = this.$route.query.project_id
            }

            if(this.$route.query.hasOwnProperty('camp')){
                this.campaign_id = this.$route.query.camp
                this.campaign_data = this.getSavedLocalItem(this.local_camp_key)
            }

            this.reCheckCartItem()

            //ซ่อน flash massage
            store.commit('changeFlashState',{show:false})

            //แสดง loading
            this.current_loading_state.show = true
            store.commit('changeLoadingState', this.current_loading_state)

        },
        computed: {
            genRouteData() {
                const data = {
                    back_route: {
                        name: 'saleOnline_propertiesList',
                        params: {project_id: (this.project_detail ? this.project_detail.project_id : 0),camp:this.campaign_id}
                    }
                }
                return data
            },
            uniqueBuildingList(){
                let uu = []
                // console.log(this.properties_list.length)
                for (let i = 0; i < this.properties_list.length; i++) {
                    if(
                        !uu.find(n => n === this.properties_list[i].building_code)
                    ){
                        uu.push(this.properties_list[i].building_code)
                    }
                }
                return uu
            }
        },
        methods:{
            async getPropertiesList(offset,limit){
                if(!offset&&!limit) {
                    //แสดง loading
                    this.current_loading_state.show = true
                    store.commit('changeLoadingState', this.current_loading_state)
                }

                let requestBody = {
                    user_id: this.getAppUserId(),
                    project_code: this.project_detail.project_code,
                    offset: offset ? offset:this.offset,
                    limit: limit ? limit:this.limit,
                    campaign_id: this.campaign_id
                }

                //ตรวจสอบ vmode
                const setting_data = this.getSavedLocalItem(this.local_setting_key)
                if (setting_data&&setting_data.view_mode=='booking') {
                    requestBody.project_is_open_for_sale = 'Y'
                    requestBody.property_is_open_for_sale = 'Y'
                }
                else if(setting_data&&setting_data.view_mode=='view'){
                    requestBody.price_total_amount = 'N'
                }else{
                    requestBody.project_is_open_for_sale = 'Y'
                    requestBody.property_is_open_for_sale = 'Y'
                }

                let promiseChecking, finalResult = []

                promiseChecking = await this.promiseHandle(this.PostHttp('Readytomove/StockByAgent',requestBody,true,'json'))

                if (!promiseChecking.error) {
                    if(promiseChecking.result.res.data.code=='000'){
                        finalResult = [...promiseChecking.result.res.data.result]
                    }
                }

                let temp_properties_list = []

                if(finalResult&&finalResult.length>0) {
                    finalResult.forEach((data, key) => {

                        // data.prop_image_link = this.getImageListByRoomType(this.project_images,data.pj_room_type_id, data.project_code)
                        // console.log("prop_img_link",data.prop_image_link)

                        data.available_status = this.checkRmsStatus(data.PD_RUNNO, data.lock_status)
                        data.PD_CODE = data.property_unit_code
                        temp_properties_list.push(data)
                    })
                }

                if(!offset&&!limit) {
                    //ซ่อน loading
                    this.current_loading_state.show = false
                    store.commit('changeLoadingState', this.current_loading_state)
                }

                return temp_properties_list
            },
            async loadRmsStatus(){
                const requestBody = {
                    ref1:(this.project_detail&&this.project_id ? this.project_detail.project_code:'')
                }
                let promiseChecking, finalResult = []

                promiseChecking = await this.promiseHandle(this.PostHttp('Readytomove/rms/statusByProject', requestBody,false,'json','rms'))

                if (!promiseChecking.error) {
                    if (promiseChecking.result.status=='success'&&promiseChecking.result.res.data.code == '000') {
                        finalResult = [...promiseChecking.result.res.data.result]
                    }
                }

                return finalResult
            },
            checkRmsStatus (ref1,property_status) {
                let status = false
                if(this.rms_status_list.length>0) {
                    let tmp_pp = this.rms_status_list.find(t =>
                        t.ref1 === ref1
                    )
                    // if(property_status=='lock'||property_status=='self_lock'||property_status=='self_confirm'||property_status=='close'){
                    //     status = false
                    // }
                    if(tmp_pp){
                        if(tmp_pp.status=='W'){
                            status = true
                        }else if(tmp_pp.status=='L'){
                            status = false
                        }else if(tmp_pp.status=='C') {
                            status = false
                        }else{
                            status = false
                        }
                    }
                }

                return status
            },
            scrollToDiv(elem_id){
                let container = this.$el.querySelector(elem_id);
                container.scrollIntoView()
            },
            togglePlanDetailDialog(data){
                this.unit_detail_dialog =  data.show
                if(data.unit_data) {
                    this.unit_detail = data.unit_data
                }
            },
            reloadUnitDetails(data){
                // console.log("re",data)
                // this.unit_detail_dialog =  data.show
                // console.log("before",this.unit_detail)
                if(data) {
                    this.unit_detail = {...data}
                    this.reload_unit_count += 1
                    this.updated_unit = {...data}
                }
                // console.log("after",this.unit_detail)
            },
            toggleQuatationDialog(quatation_form){
                this.quatation_dialog =  quatation_form.show
            },
            makeQuatation(properties){
                this.quatation_properties =  properties
                this.quatation_dialog =  true
                return true
            },
        }

    }
</script>

<style scoped>

    /*.main-app{*/
    /*    overflow: scroll;*/
    /*}*/

    .conditions-tag {
        position: absolute;
        overflow: hidden;
        left: 0;
        top: 10px;
        padding: 5px 20px 5px 20px;
        box-shadow: 1px 1px 2px #555;
    }
    .conditions-tag.sold {
        background-color: #dd3333;
    }
    .text-detail-color{
        color:#595a5c;
    }
    .unit_sold {
        position: absolute;
        top: -50px;
        left: 3%;
        -webkit-transform: translateY(20px) translateX(5px) rotate(-26deg);
        width: 50%;
        border: 2px solid red;
        color: red;
        border-radius: 4px;
        font-size: 1.2em;
        font-weight: 900;
    }
    .campaign{
        border-radius: 5px;
    }
    .campaign_name{
        /*border-top-left-radius:5px;*/
        /*border-top-right-radius:5px;*/
    }
</style>
